import * as swcHelpers from '@swc/helpers';

const appendSanitizationItems = (lineItems, sanitizationItems)=>{
    return lineItems.map((lineItem)=>{
        let updatedLineItem = lineItem;
        sanitizationItems.forEach((item, i)=>{
            if (lineItem.sku === item.actioneeSKU) {
                updatedLineItem = swcHelpers.objectSpread({}, updatedLineItem, {
                    sanitizations: [
                        item
                    ]
                });
                sanitizationItems.splice(i, 1);
            }
        });
        return updatedLineItem;
    });
};

export { appendSanitizationItems };
//# sourceMappingURL=append-sanitization-items.js.map
